import { useState, useEffect, useSelector } from './basic'
import useGeo from './useGeo'

const useAges = ({ seekingAgeFrom, seekingAgeTo } = {}) => {
  const md = useSelector(s => s.myProfile.matchDescriptor)
  const ages = useSelector(s => s.registry.ages)
  const [from, setFrom] = useState(seekingAgeFrom || md.lfAgeFrom)
  const [to, setTo] = useState(seekingAgeTo || md.lfAgeTo)

  return {
    ageFrom: {
      options: ages,
      selected: [from],
      onChange: e => {
        setFrom(e.target.value)
        e.target.value > to && setTo(e.target.value)
      },
    },
    ageTo: {
      options: ages,
      selected: [to],
      onChange: e => {
        setTo(e.target.value)
        e.target.value < from && setFrom(e.target.value)
      },
    },
  }
}

const values = string => string.split(',').map(e => +e)

const useOrientations = ({ seekingSexId: lfs, seekingOrientationId: lfo } = {}) => {
  const md = useSelector(s => s.myProfile.matchDescriptor)
  let { sexes, orientations } = useSelector(s => s.registry)
  const [sexIds, setSexIds] = useState(lfs ? values(lfs) : md.lfSexIds || [])
  const [orientationIds, setOrientationIds] = useState(lfo ? values(lfo) : md.lfOrientationIds || [])
  const options = orientations.filter(o => sexIds.includes(o.sexId))
  const available = orientationIds.filter(v => options.find(o => o.id == v))

  useEffect(() => {
    if (orientations.length && available.length != orientationIds.length) {
      setOrientationIds(available.length ? available : options.map(e => e.id))
    }
  }, ['' + available])

  return {
    sexIds: {
      selected: sexIds,
      options: sexes,
      onChange: e => setSexIds(values(e.target.value)),
    },
    orientationIds: {
      options,
      selected: orientationIds,
      onChange: e => setOrientationIds(values(e.target.value)),
    },
  }
}

const useMatch = query => ({ ...useAges(query), ...useOrientations(query), ...useGeo() })

export { useMatch as default, useMatch }
